/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions200,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions400,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions401,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions500,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptionsPathParams,
  GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptionsQueryResponse,
} from "../../types/courseRegistrationEnrollmentController/GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions.ts";
import { courseRegistrationManagementOptionViewModelSchema } from "../courseRegistrationManagementOptionViewModelSchema.ts";

export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptionsPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptionsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions200Schema =
  z.array(
    z.lazy(() => courseRegistrationManagementOptionViewModelSchema),
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions500>;

export const getApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptionsQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptions200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationEnrollmentCourseregistrationidManagementStatusOptionsQueryResponse>;
